import { render, staticRenderFns } from "./c1c9ConfirmVehicleDetails.vue?vue&type=template&id=5ddc8e42"
import script from "./c1c9ConfirmVehicleDetails.vue?vue&type=script&lang=js"
export * from "./c1c9ConfirmVehicleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports